<lh-ticket-stub>
  <div class="order-summary">
    <div class="header" [class.compact]="showBagPicker">
      <div class="pre-title">{{ 'LUGGAGE_STORAGE' | translate }}</div>
      <div class="headline" [innerHtml]="headline"></div>
      <div class="subtitle" [innerHtml]="subtitle | uppercaseFirstLetter"></div>
    </div>

    <!-- Bag selector -->
    @if (showBagPicker) {
      <div class="text-center">
        <lh-bag-selector
          [(ngModel)]="numberOfBags"
          [(bagsSelected)]="bagsSelected"
          [maxInlineBags]="3"
          [addBagSuffix]="true"
          [compact]="true"
        ></lh-bag-selector>
        <!-- Divider -->
        <div class="row item">
          <div class="col-12">
            <hr />
          </div>
        </div>
      </div>
    }

    <!-- Order lines -->
    @for (line of orderLines; track line; let i = $index) {
      <div class="row item">
        <div class="col-8">
          <div class="item-label">
            <label class="me-3">
              {{ line.description }}
              @if (line.optional) {
                <input
                  [id]="'orderLine' + i + 'Selected'"
                  [name]="'orderLine' + i + 'Selected'"
                  type="checkbox"
                  [(ngModel)]="line.selected"
                  (change)="line.onSelectedChange && line.onSelectedChange(line.selected)"
                  />
              }
            </label>
            @if (line.quantity >= 0) {
              <span class="qty-buttons">
                <button class="btn btn-info btn-qty" (click)="decrementQty(i)">–</button>
                <button class="btn btn-info btn-qty" (click)="incrementQty(i)">+</button>
              </span>
            }
            @if (line.tooltip) {
              <span class="tooltip-cta" [tooltip]="tooltipTemplate">
                <i class="icon-info"></i>
              </span>
            }
            <ng-template #tooltipTemplate>
              <div class="tooltip-content">
                @if (line.tooltip.header) {
                  <div class="tooltip-header">{{ line.tooltip.header }}</div>
                }
                <div class="tooltip-body">{{ line.tooltip.body }}</div>
              </div>
            </ng-template>
          </div>
        </div>
        <div
          class="col-4 item-price"
          [class.text-success]="line.discount || line.priceValue < 0"
          [class.disabled]="(line.optional && !line.selected) || line.quantity === 0"
          >
          @if (line.optional || line.minQuantity === 0) {
            <span>+ </span>
          }
          {{ line.priceText }}
        </div>
        @if (line.detail) {
          <div class="col-12 item-detail">{{ line.detail }}</div>
        }
      </div>
    }

    <!-- Divider -->
    <div class="row item">
      <div class="col-12">
        <hr />
      </div>
    </div>

    <div class="row item">
      <!-- Promo call-to-action -->
      <div class="col-6 discount-cta">
        @if (!discount) {
          <a id="addPromoCode" class="href" (click)="requestPromoCodeModal()">{{
            'HAVE_A_VOUCHER_OR_PROMO_CODE_MINI' | translate
          }}</a>
        }
        @if (discount) {
          <a id="addPromoCode" class="href" (click)="requestPromoCodeModal()">{{
            'CHANGE_DISCOUNT_CODE' | translate
          }}</a>
        }
      </div>

      <!-- Total -->
      <div class="col-6 total-amount">
        <span class="item-label-light">{{ totalLabel }}</span>
        <span class="item-price-lg">{{ orderTotal | price: currency : 2 : false }}</span>
      </div>
      @if (totalAlertText) {
        <div class="col-12 total-alert">
          <div class="alert alert-success">{{ totalAlertText | translate }}</div>
        </div>
      }
    </div>
  </div>
</lh-ticket-stub>
